/* istanbul ignore file */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* 

                                    ████████████                                  
                                  ██░░░░▒▒▒▒░░  ██                                
                                    ████████▒▒    ████                            
                                            ██▒▒      ██                          
                                            ██░░░░    ██                          
                                            ██▒▒▒▒▒▒    ████                      
                                        ██▓▓  ██░░▒▒▒▒      ██                    
                                      ██      ░░████▒▒▒▒      ██                  
                                    ██    ░░░░██    ██▒▒░░  ░░██                  
                                  ██      ░░██      ██░░▒▒▒▒██                    
                                ██      ████          ██▒▒██                      
                              ██      ██                ██                        
                            ██      ██                                            
                          ██      ██                                              
                        ██      ██                                                
                      ██      ██                                                  
                    ██      ██                                                    
                      ▓▓  ██                                                      
                      ▒▒▒▒▒▒                                                      
                        ██                                                        
                                                                                  
TODO: image urls are not coming from the BE so we are hammering in those values. 
    
    I know this is wrong and I feel dirty writting this code.
    God help us all.
*/

import buildImagesLinks from "./buildImagesLinks";

import Offer from "types/Offer";

export const enrichWithMockedData = (response: any, config: any) => {
  return {
    ...response,
    purchased: response.purchased.map((offer: any) => enrich(offer, config)),
    available: response.available.map((offer: any) => enrich(offer, config)),
  };
};

const enrich = (offer: Offer, config: any) => {
  return {
    ...offer,
    images: buildImagesLinks(config.cdnUrl, offer.partner.toLowerCase(), offer.campaign ? offer.campaign : "base"),
  };
};
